import axios from "axios";
import { API_URL } from "../settings";

export class Api {
  baseURL;
  axios;

  constructor() {
    this.baseURL = `${API_URL}/api/whitelabel/`;

    this.axios = axios.create({ baseURL: this.baseURL });
  }
}

export default new Api();
